// ─── Validation + Helpers (pure logic only) ──────────────────────

export const initialFormState = (saved) => ({
  ownerName: saved.ownerName || "",
  user_name: saved.user_name || "",   // ⬅️ added
  email: saved.email || "",
  pan: saved.pan || "",
  gst: saved.gst || "",
  phone: saved.phone || "",
  companyName: saved.companyName || "",
  deviceId: saved.deviceId || "",
  pricingModel: saved.pricingModel || "Peace Mode",
  countryCode: saved.countryCode || "+91",
  isActivated: saved.isActivated !== undefined ? saved.isActivated : true,
});


export const initialLocationState = (saved) => ({
  country: saved.country || "",
  state: saved.state || "",
  city: saved.city || "",
  address1: saved.address1 || "",
});

export const validationRules = (name, value) => {
  switch (name) {
    case "ownerName":
      return value ? "" : "Owner name is required";
    case "user_name":
      return value ? "" : "Unique name is required";   // ⬅️ added
    case "email":
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
        ? ""
        : "Valid email required";
    case "phone":
      return value.length === 10 ? "" : "10 digits required";
    case "pan":
      return value.length === 10 ? "" : "PAN must be 10 chars";
    case "gst":
      return value.length === 15 ? "" : "GST must be 15 chars";
    case "companyName":
      return value ? "" : "Company name is required";
    case "deviceId":
      return value ? "" : "Device ID is required";
    default:
      return "";
  }
};


// 👉 sanitizers (convert text input while typing)
export const sanitizeInput = (name, value) => {
  switch (name) {
    case "ownerName":
      return value.replace(/[^A-Za-z\s]/g, "");
    case "user_name":
      return value.replace(/[^A-Za-z0-9_]/g, "");   // ⬅️ added
    case "email":
      return value.trim();
    case "phone":
      return value.replace(/[^0-9]/g, "").slice(0, 10);
    case "pan":
      return value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 10);
    case "gst":
      return value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 15);
    default:
      return value;
  }
};



// Validate confirm password match
export const validatePasswordMatch = (password, confirmPassword) => {
  if (!confirmPassword) return "Confirm Password is required";
  if (password !== confirmPassword) return "Passwords do not match";
  return "";
};

